import React from 'react';
import capitalize from 'lodash/capitalize';
import InlineMultiSelectMenu from '../../../components/Builder/InlineMultiSelectMenu';
import UsersFilterLabel from '../Users/components/UsersFilters/UsersFilterLabel';
import { ICapricaTableStatus } from '../types';
import * as BuilderUI from '../../../components/Builder/BuilderUI';

interface IProps {
  statuses: ICapricaTableStatus[];
  setStatuses: (statuses: ICapricaTableStatus[]) => void;
}

const CapricaTableStatusFilter = ({ statuses, setStatuses }: IProps) => {
  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Status</BuilderUI.BuilderFieldLabel>
      <InlineMultiSelectMenu
        label={
          <UsersFilterLabel
            selectedValues={statuses.map((state) => capitalize(state))}
          />
        }
        labelIsAlwaysActive={true}
        options={Object.values(ICapricaTableStatus).map((state) => ({
          label: capitalize(state),
          value: state,
        }))}
        selectedKeys={statuses}
        onSubmit={setStatuses}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default CapricaTableStatusFilter;
